import { render, staticRenderFns } from "./Findpwd.vue?vue&type=template&id=3402da12&scoped=true&"
import script from "./Findpwd.vue?vue&type=script&lang=js&"
export * from "./Findpwd.vue?vue&type=script&lang=js&"
import style0 from "./Findpwd.vue?vue&type=style&index=0&id=3402da12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3402da12",
  null
  
)

export default component.exports